// extracted by mini-css-extract-plugin
export default {"wrap":"AccountsTableComponent_wrap__TwpZO","toolbar":"AccountsTableComponent_toolbar__B+QBM","tableCompact":"AccountsTableComponent_tableCompact__O7KTc"};